import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card, CardHeader, CardContent, Typography, Grid
} from '@material-ui/core';
import Chart from './Chart';
import { PERIOD_OPTIONS } from '../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 400,
  },
  content: {},
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      marginLeft: theme.spacing(1)
    }
  },
  inner: {
    minWidth: 500,
  },
  chart: {
    height: '100%'
  }
}));

const Usage = ({
  className, newEmployeesByPeriod, newPaymentsByPeriod, period, ...rest
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const selectedPeriod = PERIOD_OPTIONS.find(({ value }) => value === period);
  const periodLabelToDisplay = selectedPeriod.label.toLowerCase();

  const dataChart1 = {
    id: 'adoption',
    value: newEmployeesByPeriod,
    color: [theme.palette.colorPalette[1], theme.palette.colorPalette[2]],
    label: 'están registrados'
  };

  const dataChart2 = {
    id: 'usage',
    value: newPaymentsByPeriod,
    color: [theme.palette.colorPalette[3], theme.palette.colorPalette[2]],
    label: 'lo han utilizado'
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title={(
          <Typography
            variant="h2"
          >
            {`Uso ${periodLabelToDisplay}`}
          </Typography>
        )}
      />
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={6}
            >
              <Chart
                legendText="Registrados"
                data={dataChart1}
              />
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Chart
                legendText="Han retirado"
                data={dataChart2}
              />
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

Usage.propTypes = {
  className: PropTypes.string,
  newEmployeesByPeriod: PropTypes.number,
  newPaymentsByPeriod: PropTypes.number
};

export default Usage;
